import { render, staticRenderFns } from "./dataDialog.vue?vue&type=template&id=67edea14&scoped=true&"
import script from "./dataDialog.vue?vue&type=script&lang=js&"
export * from "./dataDialog.vue?vue&type=script&lang=js&"
import style0 from "./dataDialog.vue?vue&type=style&index=0&id=67edea14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edea14",
  null
  
)

export default component.exports